import { render, staticRenderFns } from "./ClassManager.vue?vue&type=template&id=b7e93a50&scoped=true&"
import script from "./ClassManager.vue?vue&type=script&lang=js&"
export * from "./ClassManager.vue?vue&type=script&lang=js&"
import style0 from "./ClassManager.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ClassManager.vue?vue&type=style&index=1&id=b7e93a50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e93a50",
  null
  
)

export default component.exports